import { render } from "./Inspections.vue?vue&type=template&id=20e15257&scoped=true&ts=true"
import script from "./Inspections.vue?vue&type=script&lang=ts"
export * from "./Inspections.vue?vue&type=script&lang=ts"

import "./Inspections.vue?vue&type=style&index=0&id=20e15257&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e15257"]])

export default __exports__